export const canAdminEditOwnPendingReview = ({ isAdmin, currentUserId, review }) => Boolean(
  isAdmin
  && currentUserId
  && review
  && review.userid === currentUserId
  && review.pending === true
  && review.metadata?.rejected !== true
);

const safeNumber = (value, fallback, max) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 1 && parsed <= max ? parsed : fallback;
};

const safeOptionalNumber = (value, { min = 0, max = Number.MAX_SAFE_INTEGER, integer = false } = {}) => {
  if (value === "" || value === null || value === undefined) return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < min || parsed > max) return null;
  return integer ? Math.round(parsed) : parsed;
};

const safeText = value => typeof value === "string" ? value : "";
const safeArray = value => Array.isArray(value) ? value : [];

export const normalizeReviewForEditor = (review = {}) => ({
  ...review,
  sabor: safeNumber(review.sabor, 4, 5),
  servicio: safeNumber(review.servicio, 4, 5),
  satisfaccion: safeNumber(review.satisfaccion, 4, 5),
  precio: safeNumber(review.precio, 3, 7),
  total_bill: safeOptionalNumber(review.total_bill ?? review.totalBill, { min: 0 }),
  party_size: safeOptionalNumber(review.party_size ?? review.partySize, { min: 1, max: 100, integer: true }),
  platillo: safeText(review.platillo),
  comentario: safeText(review.comentario),
  precio_label: safeText(review.precio_label),
  chef_msg: safeText(review.chef_msg),
  staff_msg: safeText(review.staff_msg),
  lo_bueno: safeArray(review.lo_bueno),
  extras: safeArray(review.extras),
  imagenes: safeArray(review.imagenes)
    .map(image => typeof image === "string" ? { url: image, name: "" } : image)
    .filter(image => image && typeof image === "object" && image.url),
  fecha: safeText(review.fecha),
});

export const findAdminEditableReviewForPlace = ({ isAdmin, currentUserId, place, reviews = [] }) => {
  if (!isAdmin || !currentUserId || !place) return null;
  if (place.addedBy !== currentUserId || place.pending !== true || place.metadata?.rejected === true) return null;

  return reviews.find(review => (
    Number(review.placeid ?? review.placeId) === Number(place.id)
    && canAdminEditOwnPendingReview({ isAdmin, currentUserId, review })
  )) || null;
};

const EDITORIAL_FIELDS = [
  "sabor", "servicio", "satisfaccion", "precio", "total_bill", "party_size", "platillo", "comentario",
  "precio_label", "chef_msg", "staff_msg", "lo_bueno", "extras", "imagenes", "fecha",
];

export const buildAdminReviewUpdate = ({ review, editedReview, placeId }) => {
  const normalized = normalizeReviewForEditor(editedReview);
  const editorial = Object.fromEntries(EDITORIAL_FIELDS.map(field => [field, normalized[field]]));
  return {
    rpcArgs: {
      p_review_id: review.id,
      p_place_id: Number(placeId),
      p_editorial: editorial,
    },
    localReview: {
      ...review,
      ...editorial,
      id: review.id,
      userid: review.userid,
      placeid: Number(placeId),
      pending: true,
    },
  };
};